import { buildQuery, requestJson } from "./apiClient";

export function listSavedSearches(params = {}) {
  return requestJson(`/api/account/saved-searches${buildQuery(params)}`);
}

export function getSavedSearch(savedSearchId) {
  return requestJson(`/api/account/saved-searches/${savedSearchId}`);
}

export function createSavedSearch(payload) {
  return requestJson("/api/account/saved-searches", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateSavedSearch(savedSearchId, payload) {
  return requestJson(`/api/account/saved-searches/${savedSearchId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function deleteSavedSearch(savedSearchId) {
  return requestJson(`/api/account/saved-searches/${savedSearchId}`, {
    method: "DELETE",
  });
}

export function markSavedSearchUsed(savedSearchId) {
  return requestJson(`/api/account/saved-searches/${savedSearchId}/use`, {
    method: "POST",
  });
}

export function setDefaultSavedSearch(savedSearchId) {
  return requestJson(`/api/account/saved-searches/${savedSearchId}/default`, {
    method: "POST",
  });
}
